import IStructuredLoggingService from '../../../../common/interfaces/structured-logging-service-interface';

export const DEFAULT_LOGS_TARGET = 'casino-orbit';
export default interface StructuredLoggingServiceInterface extends IStructuredLoggingService {
}
